import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    isSatisfied: PropTypes.bool.isRequired,
    rule: PropTypes.string.isRequired,
    showStatus: PropTypes.bool
};

function PasswordRule(props) {
    let style;
    let icon = <span className="mfa-rule-status-icon" />;

    if (props.isSatisfied && props.showStatus) {
        style = 'satisfied';
    } else {
        style = '';
    }

    return (
        <li className={'mfa-rule ' + style}>
            {icon}
            {props.rule}
        </li>
    );
}

PasswordRule.propTypes = propTypes;
export default PasswordRule;
